import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_AGENT,
  DELETE_AGENT,
  UPDATE_AGENT,
  ADD_NEW_AGENT,
} from "./actionType";

import {
  getAgentSuccess,
  getAgentFail,
  deleteAgentSuccess,
  deleteAgentFail,
  updateAgentSuccess,
  updateAgentFail,
  addAgentSuccess,
  addAgentFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveAgentApi,
  getAgentApi,
  updateAgentApi,
  deleteAgentApi,
  addNewAgentApi
} from "../../helpers/backend_helper";

function* getAgent({ payload: agent }) {
  try {
    const response = yield call(getAgentApi, agent);
    yield put(getAgentSuccess(GET_AGENT, response.data));
  } catch (error) {
    yield put(getAgentFail(GET_AGENT, error));
  }
}

function* onUpdateAgent({ payload: agent }) {
  try {
    if (agent.setApprove) {
      const response = yield call(approveAgentApi, agent);
      yield put(updateAgentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateAgentApi, agent);
      yield put(updateAgentSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAgentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAgent({ payload: agent }) {
  try {
    const response = yield call(deleteAgentApi, agent);
    yield put(deleteAgentSuccess({ agent, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAgentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAgent({ payload: agent }) {
  try {
    const response = yield call(addNewAgentApi, agent);
    yield put(addAgentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAgentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetAgent() {
  yield takeEvery(GET_AGENT, getAgent);
}

export function* watchUpdateAgent() {
  yield takeEvery(UPDATE_AGENT, onUpdateAgent);
}

export function* watchDeleteAgent() {
  yield takeEvery(DELETE_AGENT, onDeleteAgent);
}

export function* watchAddNewAgent() {
  yield takeEvery(ADD_NEW_AGENT, onAddNewAgent);
}

function* agentSaga() {
  yield all([
    fork(watchGetAgent),
    fork(watchDeleteAgent),
    fork(watchUpdateAgent),
    fork(watchAddNewAgent)
  ]);
}

export default agentSaga;
